import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import tabConfig from '../../config/tabConfig';

import '../../css/pages/manage_teams.css';

const accessOptions = tabConfig.tabs.map((tab, index) => ({
    value: index + 1,
    label: tab.label,
}));

export default function AccessMultiselect({ selectedValues, onChange }) {

    const [t] = useTranslation('global');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (value) => {
        if (selectedValues.includes(value)) {
            onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
        } else {
            onChange({ target: { value: [...selectedValues, value] } });
        }
    };

    const handleDelete = (value) => {
        onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
    };

    return (
        <div className="mill-multiselect" ref={dropdownRef}>
            <label>{t('accessPermissions')}</label>
            <div className="multiselect-line" onClick={toggleDropdown}>
                <div className="selected-values">
                    {selectedValues.map((value) => {
                        const option = accessOptions.find((o) => o.value === value);
                        return (
                            <span key={value} className="selected-chip">
                                {option ? t(option.label) : value}
                                <button className="delete-chip" onClick={(e) => { e.stopPropagation(); handleDelete(value); }}>
                                    &times;
                                </button>
                            </span>
                        );
                    })}
                </div>
                <span className="dropdown-icon material-symbols-outlined">
                    {isDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </div>
            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <ul className="dropdown-list">
                        {accessOptions.map((option) => (
                            <li
                                key={option.value}
                                className={`dropdown-item ${selectedValues.includes(option.value) ? "selected" : ""}`}
                                onClick={() => handleSelect(option.value)}
                            >
                                {t(option.label)}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
